import { createFileRoute } from '@tanstack/react-router'
import AssetLens from 'pages/assetLens/AssetLens'
import { z } from 'zod'

const searchSchema = z.object({
  tab: z.string().optional(),
})

export const Route = createFileRoute('/asset-lens/$siteID/$unitID')({
  component: AssetLens,
  staticData: {
    title: 'Asset Lens',
  },
  validateSearch: searchSchema,
})
